export default __webpack_public_path__ + "static/chat_icon-c5dffc85445c6d00f250afef1f3027db.svg";